/**
 * load spinner directive
 * @author Umer Hassan
 */

import template from './loadSpinner.html';

function loadSpinner() {
  return {
    scope: {
      btnTxt: '@', // pass in the button text
      enableSpinner: '=', // pass in the options (an object) to enable/disable spinner & text and show success/fail icon
      action: '&', // pass in the action from the parent scope that the button should perform on a click event,
      disabled: '=', // indicate when the button should be disabled
      btnType: '@', // pass in the class of the button,
      spinnerType: '@' // this should be a font-awesome class for the spinner
    },
    restrict: 'E',
    template,
    controller: 'LoadSpinnerController'
  };
}

function LoadSpinnerController($scope, $timeout) {
  function showCheck() {
    $scope.spinning = false;
    // display icon based on success or failure of the request/process
    $scope.icon = $scope.enableSpinner.success ? 'fa-check' : 'fa-times';

    $timeout(() => {
      $scope.hideText = false;
      $scope.icon = $scope.spinnerType;
    }, 1500);
  }

  $scope.icon = $scope.spinnerType;
  $scope.spinning = false;
  $scope.hideText = false;

  // Watch is required to keep track of when the request is done (so we can do the timeout trick)
  $scope.$watch('enableSpinner.enable', (newVal, oldVal) => {
    if (newVal === false && oldVal === true) {
      // if the request is executed, let's start our own timeout and then remove spinner
      $timeout(showCheck, 500);
    } else if (newVal === true && oldVal === false) {
      // Inital display of spinner on click
      $scope.spinning = true;
      $scope.hideText = true;
    }
  });
}

const directiveArr = [loadSpinner];

const controllerArr = ['$scope', '$timeout', LoadSpinnerController];

export default function (ngModule) {
  ngModule.directive('loadSpinner', directiveArr);
  ngModule.controller('LoadSpinnerController', controllerArr);
}
